import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import Orders from '@flp/components/orders/orders';
import Order from '@flp/components/orders/order';
import ImportTrucks from '@flp/components/import/trucks';
import ImportTruck from '@flp/components/import/truck';
import ImportConsignments from '@flp/components/import/consignments';
import DeliveryTrucks from '@flp/components/delivery/trucks';
import DeliveryTruck from '@flp/components/delivery/truck';
import Remainings from '@flp/components/remainings/remainings';
import Files from '@flp/components/files/files';
import Notifications from '@flp/components/notifications/notifications';
import Contacts from '@flp/components/contacts/contacts';
import User from '@flp/components/user/user';
import BillHeaders from '@flp/components/bill-headers/bill-headers';
import TransactionsHistory from '@flp/components/transactions-history/transactions-history';
import BalanceDetails from '@flp/components/balances/balance-details';
import MainLayout from '@flp/main-layout';

import { IUserSession } from '@entities/user-session';
import { UserType } from '@enums/user-type';
import { UserBalanceType } from '@enums/user-balance-type';

import { serverFetch } from '@flp/server';

interface IAppRoutes {
    userSession: IUserSession;
    appVersion: string | undefined;
}

const AppRoutes = (props: IAppRoutes) => {
    const { userSession, appVersion } = props;

    let defaultRoute;

    if (userSession.userSettings?.showOrders) {
        if (userSession.type === UserType.MainClient || userSession.type === UserType.SubClient) {
            defaultRoute = <Route index element={<Navigate replace to={`/flp/orders`} />} />;
        } else if (userSession.type === UserType.Supplier || userSession.type === UserType.Employee) {
            defaultRoute = <Route index element={<Navigate replace to={`/flp/import`} />} />;
        }
    } else if (userSession.userSettings?.showInventory) {
        defaultRoute = <Route index element={<Navigate replace to={`/flp/remainings`} />} />;
    } else if (userSession.userSettings?.showBills) {
        defaultRoute = <Route index element={<Navigate replace to={`/flp/billheaders`} />} />;
    } else if (userSession.userSettings?.showBalances) {
        defaultRoute = <Route index element={<Navigate replace to={`/flp/balances`} />} />;
        defaultRoute = <Route index element={<Navigate replace to={`/flp/whitebalances`} />} />;
    }

    return (
        <Routes>
            <Route path='/' element={<MainLayout appVersion={appVersion} />}>
                {defaultRoute}

                <Route path='flp/orders' element={<Orders />} />
                <Route path='flp/orders/:id' element={<Order />} />

                <Route path='flp/import' element={<ImportTrucks />} />
                <Route path='flp/import/:id' element={<ImportTruck />} />
                <Route path='flp/import/consignments/:truckId' element={<ImportConsignments />} />

                <Route path='flp/delivery' element={<DeliveryTrucks />} />
                <Route path='flp/delivery/:id' element={<DeliveryTruck />} />

                <Route path='flp/remainings' element={<Remainings />} />

                <Route path='flp/notifications' element={<Notifications />} />
                <Route path='flp/files' element={<Files />} />

                <Route path='flp/contacts' element={<Contacts />} />

                <Route path='flp/useraccount' element={<User />} />

                <Route path='flp/billheaders' element={<BillHeaders />} />

                <Route
                    path='flp/balances'
                    element={<BalanceDetails serverFetch={serverFetch} userBalanceType={UserBalanceType.Regular} />}
                />
                <Route
                    path='flp/whitebalances'
                    element={<BalanceDetails serverFetch={serverFetch} userBalanceType={UserBalanceType.White} />}
                />

                <Route path='flp/transactions' element={<TransactionsHistory />} />
            </Route>
        </Routes>
    );
};

export default AppRoutes;
